import { create } from 'zustand';
import { Cart, CartItem } from '../types';

interface CartState {
  cart: Cart | null;
  isOpen: boolean;
  isLoading: boolean;
  setCart: (cart: Cart) => void;
  setOpen: (open: boolean) => void;
  setLoading: (loading: boolean) => void;
  clearCart: () => void;
  itemCount: () => number;
}

export const useCartStore = create<CartState>((set, get) => ({
  cart: null,
  isOpen: false,
  isLoading: false,

  setCart: (cart) => set({ cart }),
  setOpen: (open) => set({ isOpen: open }),
  setLoading: (loading) => set({ isLoading: loading }),
  clearCart: () => set({ cart: null }),

  itemCount: () => {
    const { cart } = get();
    return cart?.items.reduce((sum: number, item: CartItem) => sum + item.quantity, 0) || 0;
  },
}));
